export default {
    common: {
        email: 'Email',
        LoginBtn: 'Se Connecter',
        SignUpBtn: `S'inscrire`,
        SubmitBtn: 'Confirmer',
        ExitBtn: 'Quitter',
        LogoutBtn: 'Déconnexion'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'Veuillez vérifier votre email pour le code de vérification.',
        VerificationCode: 'Code de vérification'
    },
    header: {
        OrderHistory: 'Historique des commandes',
        MYACCOUNT: 'MON COMPTE',
        WelcomeBack: 'Bienvenue'
    },
    detail: {
        TotalOrders: 'Total des commandes',
        TotalProducts: 'Total des produits',
        WonderlandPoints: 'Points Wonderland',
        APMCredits: 'APM Crédit',
        ExpireOn: `Expiration`,
        NoAPMCredits: 'Aucun crédit APM',
        CreditsLoading: 'Chargement des crédits'
    },
    panel: {},
    entry: {
        Client: 'Client',
        OrderDate: 'Date de la Commande',
        DeliverDate: 'Date de livraison',
        Description: 'Description',
        Total: 'Total'
    },
    board: {
        Order: 'COMMANDE',
        Date: 'DATE',
        Total: 'TOTAL'
    },
    order: {
        OrderID: 'ID Commande',
        PurchasePlace: 'Lieu',
        PurchaseDate: 'Date de la Commande',
        TotalPrice: 'Prix Total',
    },
    product: {
        Name: 'Nom',
        SKU: 'SKU',
        Size: 'Taille',
        Quantity: 'Quantité',
        Price: 'Prix',
        WarrantyUntil: `Garantie jusqu'au`,
    }
}


// WEBPACK FOOTER //
// ./src/locales/fr/index.js